import { useEffect } from 'react';

import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { ConnectivityPlugin } from '@atlaskit/editor-plugin-connectivity';

interface Options {
	collabEditInternetLost: boolean;
	internetDisconnected: boolean;
	editorFullPagePresetAPI: PublicPluginAPI<[ConnectivityPlugin]> | undefined;
}

/**
 * Override the default connectivity behaviour to keep it in sync with whether or not
 * the collaborative provider is connected or not.
 *
 * This is required because sometimes the internet will reconnect, but the provider gets stuck.
 */
export const useEditorCollabConnectivitySync = ({
	collabEditInternetLost,
	internetDisconnected,
	editorFullPagePresetAPI,
}: Options) => {
	useEffect(() => {
		const isDisconnected = collabEditInternetLost || internetDisconnected;
		if (isDisconnected) {
			editorFullPagePresetAPI?.core.actions.execute(
				editorFullPagePresetAPI?.connectivity?.commands.setMode('offline'),
			);
		} else {
			editorFullPagePresetAPI?.core.actions.execute(
				editorFullPagePresetAPI?.connectivity?.commands.setMode('online'),
			);
		}
	}, [collabEditInternetLost, internetDisconnected, editorFullPagePresetAPI]);
};
